// eslint-disable-next-line
import { Route } from 'vue-router';

import { store } from '../store';

/**
 * updates page transition classes before the route update
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
export default function(to, from, next) {
  const { profile } = store.state;
  if (profile) {
    if (to.matched[0].path === `/${profile.role}`) {
      next();
    } else {
      next(`/${profile.role}`);
    }
  } else {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    });
  }
}
